import Spinners from 'components/Common/Spinner';
import TableContainer from 'components/Common/TableContainer';
import moment from 'moment';
import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { UncontrolledTooltip } from 'reactstrap';
import { getAllPolicyReports } from 'store/Policy/action';

const ExcelReports = () => {

    const dispatch = useDispatch();

    const { allPolicyReports, loading, error } = useSelector(state => state.PolicyReducer)

    const columns = useMemo(() => [
        {
            Header: "Sr No",
            Cell: ({ row }) => row.index + 1,
        },
        // {
        //     Header: "LOB",
        //     accessor: "payload.LOB",
        //     Cell: ({ value }) => value || "-",
        // },
        {
            Header: "Status",
            accessor: "status",
            Cell: ({ value }) => value === 'failed' ? <span className='text-danger'>{value}</span> : <span className='text-success'>{value}</span> || "-",
        },
        {
            Header: "Created At",
            accessor: "created_at",
            Cell: ({ value }) => value ? moment.utc(value).format("DD/MM/YYYY hh:mm A") : "-"
        },
        {
            Header: "Completed At",
            accessor: "completed_at",
            Cell: ({ value }) => value ? moment.utc(value).format("DD/MM/YYYY hh:mm A") : "-"
        },
        {
            Header: "Action",
            accessor: "file_url",
            disableFilters: true,
            Cell: ({ row }) => {
                const { file_url, id } = row.original;
                return (
                    <ul className="list-unstyled hstack gap-1 mb-0">
                        {file_url ? <li key={`view-${id}`}>
                            <a
                                className="btn btn-sm btn-soft-info"
                                href={file_url}
                                id={`viewtooltip-${id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="mdi mdi-download" />
                            </a>
                            <UncontrolledTooltip
                                placement="top"
                                target={`viewtooltip-${id}`}
                            >
                                View Policy
                            </UncontrolledTooltip>
                        </li>: null}
                    </ul>
                );
            },
        },
    ], []);



    useEffect(() => {
        dispatch(getAllPolicyReports())
    }, [dispatch])


    return (
        <div className='page-content'>
            <h2>Policy Reports</h2>
            {loading ? <Spinners /> :
                <TableContainer
                    columns={columns}
                    data={allPolicyReports || []}
                    isGlobalFilter={false}
                    isAddOptions={false}
                    isJobListGlobalFilter={false}
                    isPagination={false}
                    iscustomPageSizeOptions={false}
                    isShowingPageLength={true}
                    customPageSize={100}
                    tableClass="table-bordered align-middle nowrap mt-2"
                    paginationDiv="col-sm-12 col-md-7"
                    pagination="pagination justify-content-end pagination-rounded"
                />}
        </div>
    )
}

export default ExcelReports